/* eslint-disable no-case-declarations */

// Package Imports
import dayjs from 'dayjs';

// Project Imports
import constants from 'core/constants/Constants';

export default function getFormattedDateByFrequency(freqType, freqValue) {
  const splittedDate = freqValue?.split(' - ');
  const startDateValue = splittedDate[0]?.trim();
  const endDateValue = splittedDate[1]?.trim();
  const startMonth = dayjs(startDateValue)?.format(constants?.mmmYYYY);
  const endMonth = dayjs(endDateValue)?.format(constants?.mmmYYYY);
  switch (freqType) {
    case 'month':
      const monthlyDate = dayjs(startDateValue, constants.dateFormatWithHyphen);
      const month = monthlyDate?.format(constants.monthFormat)?.toUpperCase();
      const monthYear = monthlyDate?.year();
      return {
        label: `${month}, ${monthYear}`,
        value: freqValue,
      };
    case 'week':
      const startWeek = dayjs(startDateValue).format(constants.mmmDYYYY);
      const endWeek = dayjs(endDateValue).format(constants.mmmDYYYY);

      return { label: `${startWeek} - ${endWeek}`, value: freqValue };
    case 'year':
      const year = startDateValue?.split('-')?.[0]?.trim();
      return { label: year, value: year };
    case 'half year':
      return { label: `${startMonth} - ${endMonth}`, value: freqValue };
    case 'day':
      const date = dayjs(freqValue)?.format(constants?.mmmDDYYYY);
      return { label: date, value: freqValue };
    case 'quarter':
      return { label: `${startMonth} - ${endMonth}`, value: freqValue };
    default:
      return null;
  }
}
